import { render } from "./SiteDisplaySettings.vue?vue&type=template&id=48b7aaca&scoped=true"
import script from "./SiteDisplaySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteDisplaySettings.vue?vue&type=script&setup=true&lang=js"

import "./SiteDisplaySettings.vue?vue&type=style&index=0&id=48b7aaca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b7aaca"],['__file',"src/components/Sites/SiteDisplaySettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48b7aaca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48b7aaca', __exports__)) {
    api.reload('48b7aaca', __exports__)
  }
  
  module.hot.accept("./SiteDisplaySettings.vue?vue&type=template&id=48b7aaca&scoped=true", () => {
    api.rerender('48b7aaca', render)
  })

}


export default __exports__